import React from "react";
import "./BenefitCard.css";

const BenefitCard = ({ icon, title, description, animationDelay }) => {
  const cardStyle = {
    animationDelay: `${animationDelay}s`,
  };

  return (
    <div className="why-choose-us-section feature-item" style={cardStyle}>
      <div className="feature-icon">{icon}</div>
      <h3 className="feature-title-text">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  );
};

export default BenefitCard;
